import { qsa, contains } from "@fluorescent/dom";
import {
  FadeUpReveal,
  FadeScaleReveal,
  FadeUpSplitReveal,
  intersectionWatcher,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  group: ".section-header, .blog-posts__item",
  revealItem:
    ".animation-fade-up-split-reveal, .animation-fade-up-reveal, .image .image__reveal-container",
};

export default node => {
  let observer = null;
  // Each group has a staggered animation delay so we get each groups container
  const revealGroup = qsa(selectors.group, node);

  const reveals = [];

  if (shouldAnimate(node)) {
    // Initialize animations and intersection observer
    // Loop through each reveal group and initialize the reveals for each item in the group
    revealGroup.forEach(item => {
      const groupReveals = [];
      qsa(selectors.revealItem, item).forEach(revealItem => {
        // check which type of reveal needs to be initialized
        if (contains(revealItem, "animation-fade-up-split-reveal")) {
          groupReveals.push(new FadeUpSplitReveal(revealItem));
        } else if (contains(revealItem, "animation-fade-up-reveal")) {
          groupReveals.push(new FadeUpReveal(revealItem));
        } else if (contains(revealItem, "image__reveal-container")) {
          groupReveals.push(new FadeScaleReveal(revealItem));
        }
      });
      reveals.push(groupReveals);
    });

    observer = intersectionWatcher(node, { cb: isVisible });
  }

  function isVisible() {
    // increment a delay for each group of reveal animations
    let revealGroupDelay = window.theme.animation.delay;
    // loop through each group
    reveals.forEach((revealGroup, i) => {
      revealGroupDelay = window.theme.animation.delay * i;

      // loop through each reveal item in the group
      revealGroup.forEach(revealItem => {
        revealItem.play(revealGroupDelay);

        if (revealItem.type === "FadeUpSplitReveal") {
          revealGroupDelay +=
            revealItem.lineCount * window.theme.animation.delay;
        } else {
          revealGroupDelay += window.theme.animation.delay;
        }
      });
    });
  }

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
